// src/lib/supabase.ts
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Variabili d\'ambiente Supabase mancanti. Assicurati di aver configurato VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY nel file .env'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Tipi per il database
export interface Database {
  public: {
    Tables: {
      databases: {
        Row: {
          id: string;
          name: string;
          description: string | null;
          record_count: number;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          name: string;
          description?: string | null;
          record_count: number;
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          name?: string;
          description?: string | null;
          record_count?: number;
          created_at?: string;
          updated_at?: string;
        };
      };
      stock_data: {
        Row: {
          id: string;
          database_id: string;
          date: string;
          ticker: string;
          open: number;
          high: number;
          low: number;
          close: number;
          volume: number;
          market_cap: number | null;
          shares_outstanding: number | null;
          one_min_high: number | null;
          five_min_high: number | null;
          five_min_low: number | null;
          low_before_12: number | null;
          low_after_12: number | null;
          high_10_11: number | null;
          low_10_11: number | null;
          volume_10_11: number | null;
          high_11_12: number | null;
          low_11_12: number | null;
          volume_11_12: number | null;
          high_12_13: number | null;
          low_12_13: number | null;
          volume_12_13: number | null;
          high_13_14: number | null;
          low_13_14: number | null;
          volume_13_14: number | null;
          high_14_15: number | null;
          low_14_15: number | null;
          volume_14_15: number | null;
          high_15_16: number | null;
          low_15_16: number | null;
          volume_15_16: number | null;
          high_30m: number | null;
          low_30m: number | null;
          volume_30m: number | null;
          hod_time: string | null;
          lod_time: string | null;
          pre_market_high: number | null;
          pre_market_high_time: string | null;
          pre_market_low: number | null;
          pre_market_low_time: string | null;
          pre_market_volume: number | null;
          gap_percent: number | null;
          created_at: string;
        };
        Insert: {
          id?: string;
          database_id: string;
          date: string;
          ticker: string;
          open: number;
          high: number;
          low: number;
          close: number;
          volume: number;
          market_cap?: number | null;
          shares_outstanding?: number | null;
          one_min_high?: number | null;
          five_min_high?: number | null;
          five_min_low?: number | null;
          low_before_12?: number | null;
          low_after_12?: number | null;
          high_10_11?: number | null;
          low_10_11?: number | null;
          volume_10_11?: number | null;
          high_11_12?: number | null;
          low_11_12?: number | null;
          volume_11_12?: number | null;
          high_12_13?: number | null;
          low_12_13?: number | null;
          volume_12_13?: number | null;
          high_13_14?: number | null;
          low_13_14?: number | null;
          volume_13_14?: number | null;
          high_14_15?: number | null;
          low_14_15?: number | null;
          volume_14_15?: number | null;
          high_15_16?: number | null;
          low_15_16?: number | null;
          volume_15_16?: number | null;
          high_30m?: number | null;
          low_30m?: number | null;
          volume_30m?: number | null;
          hod_time?: string | null;
          lod_time?: string | null;
          pre_market_high?: number | null;
          pre_market_high_time?: string | null;
          pre_market_low?: number | null;
          pre_market_low_time?: string | null;
          pre_market_volume?: number | null;
          gap_percent?: number | null;
          created_at?: string;
        };
        Update: {
          id?: string;
          database_id?: string;
          date?: string;
          ticker?: string;
          open?: number;
          high?: number;
          low?: number;
          close?: number;
          volume?: number;
          market_cap?: number | null;
          shares_outstanding?: number | null;
          one_min_high?: number | null;
          five_min_high?: number | null;
          five_min_low?: number | null;
          low_before_12?: number | null;
          low_after_12?: number | null;
          high_10_11?: number | null;
          low_10_11?: number | null;
          volume_10_11?: number | null;
          high_11_12?: number | null;
          low_11_12?: number | null;
          volume_11_12?: number | null;
          high_12_13?: number | null;
          low_12_13?: number | null;
          volume_12_13?: number | null;
          high_13_14?: number | null;
          low_13_14?: number | null;
          volume_13_14?: number | null;
          high_14_15?: number | null;
          low_14_15?: number | null;
          volume_14_15?: number | null;
          high_15_16?: number | null;
          low_15_16?: number | null;
          volume_15_16?: number | null;
          high_30m?: number | null;
          low_30m?: number | null;
          volume_30m?: number | null;
          hod_time?: string | null;
          lod_time?: string | null;
          pre_market_high?: number | null;
          pre_market_high_time?: string | null;
          pre_market_low?: number | null;
          pre_market_low_time?: string | null;
          pre_market_volume?: number | null;
          gap_percent?: number | null;
          created_at?: string;
        };
      };
    };
  };
}